import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class FbpixelService {

	constructor() { }

	fbq(type, event, jsonData){
		if(typeof window['fbq'] == "function"){
			let fbq = window['fbq'];
			fbq(type, event, jsonData);
		}
	}
	
	/**
	 * https://ads.tiktok.com/help/article/standard-events-parameters?lang=en#
	 */
	ttq(event, jsonData = null){
		if(typeof window['ttq'] != 'undefined'){
			let ttq = window['ttq'];
			if(jsonData){
				ttq.track(event, jsonData);
			}
			else {
				ttq.track(event);
			}
		}
	}
}
